import { Module } from 'vuex';

import { RootState } from 'frontend/types';

interface TranspilerShaState {
  transpilerSha: string;
}

const transpilerShaState: Module<TranspilerShaState, RootState> = {
  namespaced: true,
  state: {
    transpilerSha: '',
  },
  mutations: {
    setValue(state: TranspilerShaState, value: string) {
      state.transpilerSha = value;
    },
  },
};

export default transpilerShaState;
